import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

export default function NotFound() {
  usePageTitle('Page not found');
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface dark:bg-gray-870 text-gray-900 dark:text-gray-100 px-6 text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-brand-600 dark:text-brand-400">404</p>
      <h1 className="mt-2 text-2xl sm:text-3xl font-bold">Page not found</h1>
      <p className="mt-3 text-sm text-gray-500 dark:text-gray-400 max-w-md">
        The page you are looking for doesn't exist or may have moved.
      </p>
      <div className="mt-8 flex items-center gap-3">
        <Link
          to="/"
          className="rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-brand-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          Go to homepage
        </Link>
        <Link
          to="/dashboard"
          className="rounded-md border border-gray-300 dark:border-gray-600 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100/60 dark:hover:bg-gray-700/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
}
